import { rem } from '../../../utils/utils';

const FilterSwitch = {
  baseStyle: () => {
    return {
      container: {
        background: 'neutral.95',
        border: '1px solid',
        borderColor: 'neutral.80',
        borderRadius: '4',
        color: 'neutral.40',
        display: 'flex',
      },
      item: {
        _active: {
          background: 'neutral.100',
          color: 'purple.10',
        },
        _checked: {
          background: 'neutral.100',
          color: 'purple.10',
          cursor: 'default',
        },
        _first: {
          borderLeft: 'none',
          borderLeftRadius: '4',
        },
        _focusVisible: {
          boxShadow: 'outline',
          zIndex: 1,
        },
        _hover: {
          background: 'neutral.100',
        },
        _last: {
          borderRightRadius: '4',
        },
        alignItems: 'center',
        borderLeft: '1px solid',
        borderLeftColor: 'neutral.80',
        cursor: 'pointer',
        display: 'flex',
        fontSize: rem(14),
        gap: '4',
        lineHeight: rem(20),
        overflow: 'hidden',
        paddingBlock: rem(5),
        paddingInline: rem(11),
        position: 'relative',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        zIndex: 0,
      },
    };
  },
};

export default FilterSwitch;
